import { Route, Routes } from "react-router-dom";
import { CommodityPage } from "./pages/CommodityPage";

const Commodity = () => {
  return (
    <Routes>
      <Route index element={<CommodityPage />} />
      <Route path=":commodityId" element={<CommodityPage />} />
    </Routes>
  );
};
export default Commodity;
